import React, { useRef, useState } from 'react';
import VirtualPhotoMosaicMenu from './component/VirtualPhotoMosaicMenu';
import TileCardMenu from './component/TileCardMenu';
import CssHighlightElement from './CssHighlightElement';
import SimpleModal from '../../common/SimpleModal/SimpleModal';
import CssEditor from '../CssEditor/CssEditor';
import { useCallback } from 'react';
const getCssProperties = element => {
  let cssObject = {};
  const o = getComputedStyle(element);
  const fieldsToConsider = ['background-position', 'background-size', 'grid-row-start', 'grid-row-end', 'grid-column-start', 'grid-column-end'];
  fieldsToConsider.forEach(field => {
    cssObject[field] = o.getPropertyValue(field);
  });
  return cssObject;
};
const generateAllCssObjects = elements => {
  const object = {};
  elements.forEach(el => {
    const id = el.getAttribute('data-custom-css-id');
    object[id] = getCssProperties(el);
  });
  return object;
};
const getCustomCssSelector = htmlElement => {
  const dataCustomCssIdAttribute = htmlElement.getAttribute('data-custom-css-id');
  const selector = `${htmlElement.nodeName.toLowerCase()}[data-custom-css-id="${dataCustomCssIdAttribute}"]`; // .edit-custom-css`;
  return selector;
};
const EditCssModal = ({
  id,
  element,
  allElements = [],
  show,
  setShow,
  menuType = '',
  setElementCss,
  htmlElement,
  currentCustomCss
}) => {
  const [cssObject, setCssObject] = useState(generateAllCssObjects(allElements));
  const prevCustomCss = `{ ${currentCustomCss[getCustomCssSelector(htmlElement)] || '<inserisci-qui-il-css>'} }`;
  const menuRef = useRef(null);
  const customCssRef = useRef(`${getCustomCssSelector(htmlElement)} ${prevCustomCss}`);
  const setCssProperty = (id, prop, newVal) => {
    const newCssObject = cssObject;

    // inizializzazione
    if (!newCssObject[id]) {
      newCssObject[id] = {};
    }
    setCssObject({
      ...cssObject,
      [id]: {
        ...cssObject[id],
        [prop]: newVal
      }
    });
  };
  const closeModal = () => {
    setShow(false);
  };
  const virtualPhotoMosaicSubmit = () => {
    const fields = menuRef.current.getFields();
    const object = {};
    fields.forEach(singleField => {
      Object.keys(cssObject).forEach(key => {
        if (!object[key]) {
          object[key] = {};
        }
        object[key][singleField] = cssObject[key][singleField];
      });
    });
    setElementCss(object);
  };
  const tileCardSubmit = () => {
    const fields = menuRef.current.getFields();
    const object = {};
    fields.forEach(singleField => {
      Object.keys(cssObject).forEach(key => {
        if (!object[key]) {
          object[key] = {};
        }
        object[key][singleField] = cssObject[key][singleField];
      });
    });
    setElementCss(object);
  };
  const customCssSubmit = () => {
    const selector = getCustomCssSelector(htmlElement);
    const styles = customCssRef.current.substring(customCssRef.current.indexOf('{') + 1, customCssRef.current.indexOf('}'));
    console.log('selector', selector);
    console.log('styles', styles);
    const newCustomCss = {
      ...currentCustomCss,
      [selector]: styles
    };
    console.log(newCustomCss);
    setElementCss(newCustomCss);
  };
  const customCssOnChange = useCallback((value, viewUpdate) => {
    console.log('value:', value.doc.getValue());
    customCssRef.current = value.doc.getValue();
  }, []);
  const menuMap = menuType => {
    switch (menuType) {
      case 'virtual-photo-mosaic-element':
        return {
          subtitle: "Personalizza la posizione e la dimensione dell'immagine del mosaico.",
          component: /*#__PURE__*/React.createElement(VirtualPhotoMosaicMenu, {
            ref: menuRef,
            id: id,
            cssObject: cssObject,
            setCssProperty: setCssProperty,
            htmlElement: htmlElement
          }),
          handleSubmit: virtualPhotoMosaicSubmit
        };
      case 'tile-card-element':
        return {
          subtitle: "Personalizza la posizione e la dimensione dell'immagine delle card.",
          component: /*#__PURE__*/React.createElement(TileCardMenu, {
            ref: menuRef,
            id: id,
            cssObject: cssObject,
            setCssProperty: setCssProperty,
            htmlElement: htmlElement
          }),
          handleSubmit: tileCardSubmit
        };
      case 'css':
        return {
          subtitle: "Personalizza lo stile dell'elemento.",
          component: /*#__PURE__*/React.createElement(CssEditor, {
            onChange: customCssOnChange,
            value: customCssRef.current
          }),
          handleSubmit: customCssSubmit
        };
      default:
        return {
          subtitle: "Personalizza lo stile dell'elemento.",
          component: /*#__PURE__*/React.createElement(CssEditor, {
            onChange: customCssOnChange,
            value: customCssRef.current
          }),
          handleSubmit: customCssSubmit
        };
    }
  };
  const highlightElement = {
    'virtual-photo-mosaic-element': true,
    'tile-card-element': true
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SimpleModal, {
    onSubmit: menuMap(menuType).handleSubmit,
    onCancel: closeModal,
    title: "Personalizza l'elemento",
    subtitle: menuMap(menuType) ? menuMap(menuType).subtitle : '',
    showModal: show
  }, /*#__PURE__*/React.createElement("div", {
    className: "edit-css-modal-body"
  }, menuMap(menuType).component || '')), show && highlightElement[menuType] ? /*#__PURE__*/React.createElement(CssHighlightElement, {
    htmlElement: htmlElement
  }) : null);
};
export default EditCssModal;